import { debounce } from 'Utils/common';

export default (el, binding) => {
  if (binding.value !== binding.oldValue) { // change debounce only if interval has changed
    el.addEventListener('input', debounce(() => {
      el.dispatchEvent(new Event('change'));
    }, parseInt(binding.value, 10) || 500));
  }
};
